module.exports = __webpack_public_path__ + "static/media/Pouť-94-2.23ad0445.jpg";